import TapeItem from './TapeItem';

const Tape = ({ data, isCuttingLineEnabled }) => {
    const handleScaleCalculated = (scale) => {
        
    };

    return (
        <>
            <div className="tape-container" id="printable-area"  style={{ width: "80mm" }}>
                {data.map((item, index) => (
                    <div className="printable-tape-item" key={index}>
                        <TapeItem
                            checkIndex={index}
                            display='tape'
                            {...item}
                            isCuttingLineEnabled={isCuttingLineEnabled}
                            onScaleCalculated={(scale) => {handleScaleCalculated(scale)}}
                        />
                    </div>
                ))}
            </div>
        </>
    );
};

export default Tape;


